import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { lookInside } from '../data/content';
import { CtaButton } from './CtaButton';
export function LookInside() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const slide = lookInside[index];
  useEffect(() => {
    lookInside.forEach(item => {
      const preload = new Image();
      preload.src = item.image;
    });
  }, []);
  const go = (next: number) => {
    const total = lookInside.length;
    const target = (next % total + total) % total;
    if (target === index) return;
    setDirection(next > index ? 1 : -1);
    setIndex(target);
  };
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-127" data-mp="1mw1vdspdwjjb">
      <div className="mx-auto max-w-5xl" data-id="element-128" data-mp="18zelkpcc1yvz">
        <div className="text-center" data-id="element-129" data-mp="190pnejm7wwkg">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-130" data-mp="1dxpumxut05d5">
            No surprises
          </span>
          <h2 className="mt-4 font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-131" data-mp="a13b34dcmokl">
            <span aria-hidden="true" data-id="element-132" data-mp="63fb3mwsu5lu">🔍 </span>See the Material From the Inside
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-ink/55" data-id="element-133" data-mp="jyrfkm0rbafy">
            Real pages from the volumes — exactly what you download and print.
          </p>
        </div>

        <div className="mt-10 grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_20rem]" data-id="element-134" data-mp="3ni3y7ey36t6q">
          <div className="relative mx-auto w-full max-w-sm md:max-w-none" data-id="element-135" data-mp="3ijsn70w22cmx">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-white shadow-soft" data-id="element-136" data-mp="129hlmvbeeb9">
              <AnimatePresence initial={false} mode="popLayout" data-id="element-137" data-mp="3sfmanfbbbqjh">
                <motion.img key={slide.image} src={slide.image} alt={`${slide.title} — sample page from the Math Ready pack`} draggable={false} initial={{
                opacity: 0,
                x: direction * 32
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction * -32
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="absolute inset-0 h-full w-full object-contain p-1" data-id="element-138" data-mp="34r2yupt20vmn" />
              </AnimatePresence>
            </div>

            <button type="button" onClick={() => go(index - 1)} aria-label="Previous page" className="absolute -left-3 top-1/2 -translate-y-1/2 rounded-full bg-white p-2.5 text-ink shadow-soft transition-colors duration-200 hover:bg-brand hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-139" data-mp="kq95yo5e7672">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-140" data-mp="2562wfekpyjgr" />
            </button>
            <button type="button" onClick={() => go(index + 1)} aria-label="Next page" className="absolute -right-3 top-1/2 -translate-y-1/2 rounded-full bg-white p-2.5 text-ink shadow-soft transition-colors duration-200 hover:bg-brand hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-141" data-mp="2a4xhyoa2mm4k">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-142" data-mp="26hfslhwymrhh" />
            </button>
          </div>

          <div className="text-center md:text-left" data-id="element-143" data-mp="21i36x0htrqgh">
            <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-144" data-mp="21jxp471pp4gv">
              {slide.level}
            </p>
            <h3 className="mt-2 font-display text-xl font-bold leading-tight text-ink" data-id="element-145" data-mp="1rk6xcd4jd3kh">
              {slide.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-146" data-mp="1njdazo6qrwtp">
              {slide.text}
            </p>

            <div className="mt-6 flex items-center justify-center gap-2 md:justify-start" data-id="element-147" data-mp="3lwwqutqzsarc">
              {lookInside.map((item, i) => <button key={item.title} type="button" onClick={() => go(i)} aria-label={`Show page ${i + 1}: ${item.title}`} aria-current={i === index} className={`h-2 rounded-full transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 ${i === index ? 'w-6 bg-brand' : 'w-2 bg-ink/20'}`} data-id="element-148" data-mp="3hurzk1o0nq7v" data-mpi={i} />)}
              <span className="ml-2 text-xs font-semibold text-ink/45" data-id="element-149" data-mp="3b01i9l5fdjxc">
                {index + 1} / {lookInside.length}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-150" data-mp="2w9aqgd3u2ku8">
          <CtaButton href="#offer" data-id="element-151" data-mp="319gl825egngj" />
        </div>
      </div>
    </section>;
}